import React, { useRef, useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { FxLabel } from "./FxLabel";
import axios from "axios";

/*
ㄱ. 기능
1. 인풋 파일 필드 생성 - 파일 첨부
2. 파일 업로드

ㄴ. 형식 (add 동일) - 어떤 페이지건 아래의 형식으로 생성하되 ATTR_VAL_LIST의 fileKey는 테이블의 pk값, flieUrl은 페이지구분값을 넣으면 된다.
ui-4-1-edit	input	file	121	첨부	file		{"type":"file", "fileKey" : "facNo", "fileUrl" : "4_1"}			N	Y		0		Y		N	-1	1	20221014104636	1	20221014104636
*/
export const fileSubmit = () => {
  document.getElementById("btnSubmit").click();
};

export const FxFile = (props) => {
  const { attr, onChangeValue, fxInObj, inputType } = props;
  const defaultValue = fxInObj[attr.attrName];
  const disabled = attr.readOnlyYn === "Y";
  const sx = {};
  const fileInput = React.useRef(null);
  const [selectedFile, setSelectedFile] =
    React.useState("선택된 파일이 없습니다.");

  // const [uploadInfo, setUploadInfo] = React.useState();

  // useEffect(() => {
  //   console.log("useEffect!!", uploadInfo);
  // }, [uploadInfo]);

  if (attr.uiWidth > 0) {
    sx.minWidth = attr.uiWidth;
    sx.width = attr.uiWidth;
  } else {
    sx.width = "100%";
  }
  sx.display = "none";

  function onChange(event) {
    const selectedFile = [...event.target.files];
    const fileReader = new FileReader();
    fileReader.readAsDataURL(selectedFile[0]);
    fileReader.onload = function () {
      console.log("*** FxFile ***", fileReader.result);
      setSelectedFile(
        selectedFile[0].name + "  (SIZE:" + selectedFile[0].size + ")"
      );
    };

    //선택한 파일값 대신 페이지의 pk 컬럼명을 알기 위해 attrValList 넘김.
    onChangeValue(event.target.id, attr.attrValList);
  }

  console.log(
    "*** FxFile ***",
    inputType,
    attr.attrName,
    fxInObj[attr.attrName]
  );

  const onFileSubmit = async (e) => {
    e.preventDefault();
    e.persist();

    let files = e.target.file.files;
    let formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }

    let dataSet = {
      url: localStorage.getItem("fileInfoUrl"),
      id: localStorage.getItem("fileInfoId"),
    };

    const json = JSON.stringify(dataSet);
    const blob = new Blob([json], { type: "application/json" });
    formData.append("data", blob);

    const postSurvey = await axios({
      method: "POST",
      url: "/api/open/upload",
      mode: "cors",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      data: formData,
    });

    localStorage.setItem("fileInfoUrl", "");
    localStorage.setItem("fileInfoId", "");
    console.log(postSurvey);
  };

  // function fileSizeCheck (file) {
  //   if (file.size > (1024 * 1024 * 1024 * 5)) { // 5GB 이하 파일만 업로드 가능
  //      return alert('5GB 이하인 파일만 업로드 가능합니다.')
  //    }
  //  }

  return (
    <>
      <FxLabel attr={attr} inputType={inputType} />
      <Button
        className="FxButton"
        style={{ height: "33px" }}
        onClick={function () {
          fileInput.current.click();
        }}
      >
        파일 업로드
      </Button>
      <form onSubmit={(e) => onFileSubmit(e)}>
        <input
          className="FxTextField"
          type="file"
          ref={fileInput}
          key={attr.attrName}
          id={attr.attrName}
          style={sx}
          defaultValue={defaultValue}
          disabled={disabled}
          onChange={onChange}
        />
        <span className="FxLabel FxLabelSearch">{selectedFile}</span>
        <button hidden type="submit" id="btnSubmit">
          제출
        </button>
      </form>
    </>
  );
};



export const FxFile2 = (props) => {
  const { attrClass, para, defaultValue } = props;
  const sx = attrClass.getStyle();  
  const fileInput = React.useRef(null);
  const attr = attrClass.getAttr();
  const [selectedFile, setSelectedFile] =
    React.useState("선택된 파일이 없습니다.");

  sx.display = "none";

  function onChange(event) {
    const selectedFile = [...event.target.files];
    const fileReader = new FileReader();
    fileReader.readAsDataURL(selectedFile[0]);
    fileReader.onload = function () {
      console.log("*** FxFile ***", fileReader.result);
      setSelectedFile(
        selectedFile[0].name + "  (SIZE:" + selectedFile[0].size + ")"
      );
    };

    //선택한 파일값 대신 페이지의 pk 컬럼명을 알기 위해 attrValList 넘김.
    if (para.onChange) para.onChange(event.target.id, attr.attrValList);
  }

  const onFileSubmit = async (e) => {
    e.preventDefault();
    e.persist();

    let files = e.target.file.files;
    let formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }

    let dataSet = {
      url: localStorage.getItem("fileInfoUrl"),
      id: localStorage.getItem("fileInfoId"),
    };

    const json = JSON.stringify(dataSet);
    const blob = new Blob([json], { type: "application/json" });
    formData.append("data", blob);

    const postSurvey = await axios({
      method: "POST",
      url: "/api/open/upload",
      mode: "cors",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      data: formData,
    });

    localStorage.setItem("fileInfoUrl", "");
    localStorage.setItem("fileInfoId", "");
    console.log(postSurvey);
  };

  // function fileSizeCheck (file) {
  //   if (file.size > (1024 * 1024 * 1024 * 5)) { // 5GB 이하 파일만 업로드 가능
  //      return alert('5GB 이하인 파일만 업로드 가능합니다.')
  //    }
  //  }

  return (
    <>
      <Button
        className="FxButton"
        style={{ height: "33px" }}
        onClick={function () {
          fileInput.current.click();
        }}
      >
        파일 업로드
      </Button>
      <form onSubmit={(e) => onFileSubmit(e)}>
        <input
          className="FxTextField"
          type="file"
          ref={fileInput}
          key={attrClass.getId()}
          id={attrClass.getId()}
          style={sx}
          defaultValue={defaultValue}
          disabled={attrClass.isDisable()}
          onChange={onChange}
        />
        <span className="FxLabel FxLabelSearch">{selectedFile}</span>
        <button hidden type="submit" id="btnSubmit">
          제출
        </button>
      </form>
    </>
  );
};
